import { type ReactNode } from 'react';

/**
 * @public
 */
export interface EmptyStateSlotProps {
  children: ReactNode;
}

/**
 * @public
 */
export const EmptyStateSlot = ({ children }: EmptyStateSlotProps) => (
  <>{children}</>
);
